import { Vue, Prop, Component } from "vue-property-decorator";

@Component
export default class NotificationPreferences extends Vue {
    @Prop() id!: string;
    @Prop() username!: string;
    @Prop() selfScheduleOpening!: boolean;
    @Prop() selfScheduleClosing!: boolean;
    @Prop() departmentNeedsAvaliable!: boolean;
    @Prop() shiftsAvaliableForTrade!: boolean;
    @Prop() shiftTradeOffered!: boolean;
    @Prop() shiftTradeOfferAccepted!: boolean;
    @Prop() requestApproved!: boolean;
    @Prop() vacationBiddingTierOpening!: boolean;
    @Prop() vacationBiddingTierClosing!: boolean;
}

